import { routes } from '~/shared/constants/routes';
import { getSearchParamsValues } from '~/shared/lib/searchParams';

const payoutTradersSearchParamNames = {
    mode: 'mode',
    traderName: 'traderName',
    bankAccountId: 'bank_account_id',
} as const;

interface PayoutTradersSearchParams {
    traderName?: string;
    bankAccountId?: string;
}

export const getPayoutTradersSearchParams = (searchParams: URLSearchParams): PayoutTradersSearchParams => {
    return getSearchParamsValues<PayoutTradersSearchParams>(searchParams, {
        traderName: payoutTradersSearchParamNames.traderName,
        bankAccountId: payoutTradersSearchParamNames.bankAccountId,
    });
};

export const createPayoutTraderUrl = (traderId: string) => {
    return routes['payout-trader'].replace(':traderId', encodeURIComponent(traderId));
};
